<div class="header-buttons d-flex justify-content-between align-items-center">
  <a class="header-button header-button_freepayment" routerLink="/freepayment">{{ 'BUTTON.REPAYMENT' | translate }}</a>
  <a (click)="onNavigate()" class="header-button header-button_login" routerLink="auth/login">
    {{ 'BUTTON.USER_ROOM' | translate }}
    <img alt="arrow" src="assets/images/icons/arrow.svg" />
  </a>
</div>
